<script>
import ButtonImage from '../image/Component.vue'
export default ButtonImage
</script>
